import { ReactNode } from "react"

type AdminPageTemplateProps = {
  children: ReactNode;
  title: ReactNode;
}

const AdminPageTemplate = ({ children, title }: AdminPageTemplateProps): JSX.Element => {
  return (
    <div className="flex flex-col h-[95vh]">
      <div className="bg-admin-blue-500 h-fit p-3w">
        <h1 className="text-header4 md:text-header3 text-grey-white m-auto w-full md:w-3/4">{title}</h1>
      </div>
      <div className="bg-admin-bg p-3w h-full">
        <div className="m-auto w-full md:w-3/4">
          {children}
        </div>
      </div>
    </div>)
}

export default AdminPageTemplate;